import { html, render, nothing } from "lit-html";

export class StockInfoList extends HTMLElement {
    constructor() {
        super();
    }

    /* #region Public */
    public setData(stockInfo: IStockInfo[]) {
        this.stockInfo = stockInfo;
        this.render();
    }
    /* #endregion */

    /* #region Markup */
    private template = (i: IStockInfo[]) => html`
        ${i && i.length ? html`<ul>
            ${i.map(s => html`<li>
                <span class="stock-name">${s.stockName}:</span>
                <span class="stock-text" style="${(s.color ? "color:" + s.color : "")}">${s.text}</span>
            </li>`)}
        </ul>` : nothing}`;
    /* #endregion */

    /* #region Private */
    private stockInfo: IStockInfo[] = null;

    private render() {
        if (this.isConnected) {
            render(this.template(this.stockInfo), this);
        }
    }
    /* #endregion */

    connectedCallback() { 
        if (this.stockInfo) {
            this.render();
        }
    }
}

export interface IStockInfo {
    stockName: string;
    quantity: number;
    text: string;
    color: string;
}

customElements.define("stock-info-list", StockInfoList);